var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckRojo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.3501 3.58581V1.62331H6.39177L5.0001 0.244141L3.62926 1.62331H1.66676V3.58581L0.287598 4.95664L1.66676 6.34831V8.30664H3.62926L5.0001 9.68581L6.39177 8.30664H8.3501V6.34831L9.72926 4.95664L8.3501 3.58581ZM3.67926 2.89414C4.0876 2.89414 4.41677 3.22331 4.41677 3.63581C4.41677 3.8314 4.33906 4.01899 4.20076 4.1573C4.06245 4.29561 3.87486 4.37331 3.67926 4.37331C3.26676 4.37331 2.9376 4.04414 2.9376 3.63581C2.9376 3.22331 3.26676 2.89414 3.67926 2.89414ZM6.34176 7.03997C5.93343 7.03997 5.60427 6.70664 5.60427 6.29831C5.60427 6.10271 5.68197 5.91512 5.82027 5.77682C5.95858 5.63851 6.14617 5.56081 6.34176 5.56081C6.7501 5.56081 7.08343 5.88997 7.08343 6.29831C7.08343 6.49501 7.00529 6.68366 6.8662 6.82275C6.72711 6.96183 6.53847 7.03997 6.34176 7.03997ZM3.54176 7.05247L2.91676 6.42747L6.47093 2.87331L7.09593 3.49831L3.54176 7.05247Z",
    fill: "#EF4136"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckRojo);
export default __webpack_public_path__ + "static/media/checkRojo.64186c41031c9202b1134ba7a8e408b7.svg";
export { ForwardRef as ReactComponent };